export default __webpack_public_path__ + "static/media/pantry2-after2-1024w.03d9ae77.png";